<!--
GlobalEventSelector.vue

Organizer EMS topbar 全域活動選擇器

@author: wyan@yoursaas.com
@date: 2026-07-20
-->

<template>
	<div class="global-event-selector d-none d-lg-flex align-items-center">
		<label class="visually-hidden" for="topbar-current-event">
			{{ $t('event-settings.context.label') }}
		</label>
		<i class="ri-calendar-event-line text-info me-2"></i>
		<select
			id="topbar-current-event"
			class="form-select"
			:value="currentEvid"
			:disabled="events.length === 0"
			:aria-label="$t('event-settings.context.label')"
			@change="handleChange"
		>
			<option value="">
				{{ $t('event-settings.context.empty') }}
			</option>
			<option
				v-for="event in events"
				:key="event.evid"
				:value="event.evid"
			>
				{{ event.cname || event.ename || event.evid }}
			</option>
		</select>
	</div>
</template>

<style lang="scss" scoped>
.global-event-selector {
	flex: 1 1 24rem;
	min-width: 12rem;
	max-width: none;
	margin-inline: 0.75rem;

	.form-select {
		flex: 1 1 auto;
		min-width: 0;
		max-width: none;
		height: 40px;
		padding: 0.5rem 2.7rem 0.5rem 0.9rem;
		color: var(--bs-body-color);
		font-size: 16px;
		line-height: 24px;
		background-color: var(--bs-app-bg);
		border-color: transparent;
		border-radius: var(--bs-app-radius);
		box-shadow: none;

		&:focus {
			border-color: rgba(var(--bs-theme-rgb), 0.5);
			box-shadow: 0 0 0 0.18rem rgba(var(--bs-theme-rgb), 0.1);
		}
	}
}
</style>

<script setup>
import { useCurrentEvent } from '@/composables/useCurrentEvent';

const { events, currentEvid, selectEvent } = useCurrentEvent();

const handleChange = async event => {
	const nextEvid = `${event.target.value || ''}`.trim();
	const beforeChangeEvent = new CustomEvent(
		'organizer:before-current-event-change',
		{
			cancelable: true,
			detail: {
				from: currentEvid.value,
				to: nextEvid,
			},
		}
	);
	if (!window.dispatchEvent(beforeChangeEvent)) {
		event.target.value = currentEvid.value;
		return;
	}
	await selectEvent(nextEvid);
};
</script>
